import { call, put, takeLatest } from 'redux-saga/effects';
import * as types from '../../../actions/index.types';
import * as req from '../../../../axios/request/SocietyPortal/MemberPortalReqs/MemberPortalReqs';

function* getSummary(action) {
    try {
        const result = yield call(req.getMemberSummaryReq, action);
        if (result?.success === true) {
            yield put({ type: types.MEMBER_GET_SUMMARY_SUCCESS, payload: result.data });
        } else {
            yield put({ type: types.MEMBER_GET_SUMMARY_FAILURE, message: result?.response?.data?.message });
        }
    } catch (e) {
        yield put({ type: types.MEMBER_GET_SUMMARY_FAILURE, message: e?.message });
    }
}

function* getFlats(action) {
    try {
        const result = yield call(req.getMemberFlatsReq, action);
        if (result?.success === true) {
            yield put({ type: types.MEMBER_GET_FLATS_SUCCESS, payload: result.data });
        } else {
            yield put({ type: types.MEMBER_GET_FLATS_FAILURE, message: result?.response?.data?.message });
        }
    } catch (e) {
        yield put({ type: types.MEMBER_GET_FLATS_FAILURE, message: e?.message });
    }
}

function* getInvoices(action) {
    try {
        const result = yield call(req.getMemberInvoicesReq, action);
        if (result?.success === true) {
            yield put({
                type: types.MEMBER_GET_INVOICES_SUCCESS,
                payload: { rows: result.data, pagination: result.meta?.pagination },
            });
        } else {
            yield put({ type: types.MEMBER_GET_INVOICES_FAILURE, message: result?.response?.data?.message });
        }
    } catch (e) {
        yield put({ type: types.MEMBER_GET_INVOICES_FAILURE, message: e?.message });
    }
}

function* getInvoiceDetails(action) {
    try {
        const result = yield call(req.getMemberInvoiceDetailsReq, action);
        if (result?.success === true) {
            yield put({ type: types.MEMBER_GET_INVOICE_DETAILS_SUCCESS, payload: result.data });
        } else {
            yield put({ type: types.MEMBER_GET_INVOICE_DETAILS_FAILURE, message: result?.response?.data?.message });
        }
    } catch (e) {
        yield put({ type: types.MEMBER_GET_INVOICE_DETAILS_FAILURE, message: e?.message });
    }
}

function* getPayments(action) {
    try {
        const result = yield call(req.getMemberPaymentsReq, action);
        if (result?.success === true) {
            yield put({
                type: types.MEMBER_GET_PAYMENTS_SUCCESS,
                payload: { rows: result.data, pagination: result.meta?.pagination },
            });
        } else {
            yield put({ type: types.MEMBER_GET_PAYMENTS_FAILURE, message: result?.response?.data?.message });
        }
    } catch (e) {
        yield put({ type: types.MEMBER_GET_PAYMENTS_FAILURE, message: e?.message });
    }
}

function* getPaymentDetails(action) {
    try {
        const result = yield call(req.getMemberPaymentDetailsReq, action);
        if (result?.success === true) {
            yield put({ type: types.MEMBER_GET_PAYMENT_DETAILS_SUCCESS, payload: result.data });
        } else {
            yield put({ type: types.MEMBER_GET_PAYMENT_DETAILS_FAILURE, message: result?.response?.data?.message });
        }
    } catch (e) {
        yield put({ type: types.MEMBER_GET_PAYMENT_DETAILS_FAILURE, message: e?.message });
    }
}

function* getLedger(action) {
    try {
        const result = yield call(req.getMemberLedgerReq, action);
        if (result?.success === true) {
            yield put({ type: types.MEMBER_GET_LEDGER_SUCCESS, payload: result.data });
        } else {
            yield put({ type: types.MEMBER_GET_LEDGER_FAILURE, message: result?.response?.data?.message });
        }
    } catch (e) {
        yield put({ type: types.MEMBER_GET_LEDGER_FAILURE, message: e?.message });
    }
}

/* ── Complaints ─────────────────────────────────────────────────────────── */

function* getComplaints(action) {
    try {
        const result = yield call(req.getMemberComplaintsReq, action);
        if (result?.success === true) {
            yield put({
                type: types.MEMBER_GET_COMPLAINTS_SUCCESS,
                payload: { rows: result.data, pagination: result.meta?.pagination },
            });
        } else {
            yield put({ type: types.MEMBER_GET_COMPLAINTS_FAILURE, message: result?.response?.data?.message });
        }
    } catch (e) {
        yield put({ type: types.MEMBER_GET_COMPLAINTS_FAILURE, message: e?.message });
    }
}

function* getComplaintDetails(action) {
    try {
        const result = yield call(req.getMemberComplaintDetailsReq, action);
        if (result?.success === true) {
            yield put({ type: types.MEMBER_GET_COMPLAINT_DETAILS_SUCCESS, payload: result.data });
        } else {
            yield put({ type: types.MEMBER_GET_COMPLAINT_DETAILS_FAILURE, message: result?.response?.data?.message });
        }
    } catch (e) {
        yield put({ type: types.MEMBER_GET_COMPLAINT_DETAILS_FAILURE, message: e?.message });
    }
}

function* getComplaintEnums(action) {
    try {
        const result = yield call(req.getMemberComplaintEnumsReq, action);
        if (result?.success === true) {
            yield put({ type: types.MEMBER_GET_COMPLAINT_ENUMS_SUCCESS, payload: result.data });
        } else {
            yield put({ type: types.MEMBER_GET_COMPLAINT_ENUMS_FAILURE, message: result?.response?.data?.message });
        }
    } catch (e) {
        yield put({ type: types.MEMBER_GET_COMPLAINT_ENUMS_FAILURE, message: e?.message });
    }
}

// The write sagas mirror the Complaint slice: onSuccess(result) fires only on a
// successful response, so screens can chain uploads or navigate.
function* createComplaint(action) {
    try {
        const result = yield call(req.createMemberComplaintReq, action);
        if (result?.success === true) {
            yield put({ type: types.MEMBER_CREATE_COMPLAINT_SUCCESS, payload: result.data });
            action.data?.onSuccess?.(result);
        } else {
            yield put({ type: types.MEMBER_CREATE_COMPLAINT_FAILURE, message: result?.response?.data?.message });
        }
    } catch (e) {
        yield put({ type: types.MEMBER_CREATE_COMPLAINT_FAILURE, message: e?.message });
    }
}

function* uploadComplaintAttachments(action) {
    try {
        const result = yield call(req.uploadMemberComplaintAttachmentsReq, action);
        if (result?.success === true) {
            yield put({ type: types.MEMBER_UPLOAD_COMPLAINT_ATTACHMENTS_SUCCESS, payload: result.data });
            action.data?.onSuccess?.(result);
        } else {
            yield put({ type: types.MEMBER_UPLOAD_COMPLAINT_ATTACHMENTS_FAILURE, message: result?.response?.data?.message });
        }
    } catch (e) {
        yield put({ type: types.MEMBER_UPLOAD_COMPLAINT_ATTACHMENTS_FAILURE, message: e?.message });
    }
}

function* addComplaintComment(action) {
    try {
        const result = yield call(req.addMemberComplaintCommentReq, action);
        if (result?.success === true) {
            yield put({ type: types.MEMBER_ADD_COMPLAINT_COMMENT_SUCCESS, payload: result.data });
            action.data?.onSuccess?.(result);
        } else {
            yield put({ type: types.MEMBER_ADD_COMPLAINT_COMMENT_FAILURE, message: result?.response?.data?.message });
        }
    } catch (e) {
        yield put({ type: types.MEMBER_ADD_COMPLAINT_COMMENT_FAILURE, message: e?.message });
    }
}

function* rateComplaint(action) {
    try {
        const result = yield call(req.rateMemberComplaintReq, action);
        if (result?.success === true) {
            yield put({ type: types.MEMBER_RATE_COMPLAINT_SUCCESS, payload: result.data });
            action.data?.onSuccess?.(result);
        } else {
            yield put({ type: types.MEMBER_RATE_COMPLAINT_FAILURE, message: result?.response?.data?.message });
        }
    } catch (e) {
        yield put({ type: types.MEMBER_RATE_COMPLAINT_FAILURE, message: e?.message });
    }
}

export default function* MemberPortalSaga() {
    yield takeLatest(types.MEMBER_GET_SUMMARY, getSummary);
    yield takeLatest(types.MEMBER_GET_FLATS, getFlats);
    yield takeLatest(types.MEMBER_GET_INVOICES, getInvoices);
    yield takeLatest(types.MEMBER_GET_INVOICE_DETAILS, getInvoiceDetails);
    yield takeLatest(types.MEMBER_GET_PAYMENTS, getPayments);
    yield takeLatest(types.MEMBER_GET_PAYMENT_DETAILS, getPaymentDetails);
    yield takeLatest(types.MEMBER_GET_LEDGER, getLedger);
    yield takeLatest(types.MEMBER_GET_COMPLAINTS, getComplaints);
    yield takeLatest(types.MEMBER_GET_COMPLAINT_DETAILS, getComplaintDetails);
    yield takeLatest(types.MEMBER_GET_COMPLAINT_ENUMS, getComplaintEnums);
    yield takeLatest(types.MEMBER_CREATE_COMPLAINT, createComplaint);
    yield takeLatest(types.MEMBER_UPLOAD_COMPLAINT_ATTACHMENTS, uploadComplaintAttachments);
    yield takeLatest(types.MEMBER_ADD_COMPLAINT_COMMENT, addComplaintComment);
    yield takeLatest(types.MEMBER_RATE_COMPLAINT, rateComplaint);
}
